export default "__VITE_ASSET__Lk8bSDNX__"